import { render } from "./Merch.vue?vue&type=template&id=36a719bd&scoped=true"
import script from "./Merch.vue?vue&type=script&lang=js"
export * from "./Merch.vue?vue&type=script&lang=js"

import "./Merch.vue?vue&type=style&index=0&id=36a719bd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36a719bd"]])

export default __exports__